import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";

const BACK = { "/configure": "/", "/schedule": "/configure", "/contact": "/schedule" };

export const Header = () => {
  const loc = useLocation();
  const nav = useNavigate();
  const isHome = loc.pathname === "/";
  const muted = "#C9B8A3";

  const goBack = () => {
    const target = BACK[loc.pathname];
    if (target) nav(target);
    else if (window.history.length > 1) nav(-1);
    else nav("/");
  };

  return (
    <header className="sticky top-0 z-40 pp-dark" data-testid="site-header">
      <div className="w-full px-3 sm:px-6 flex items-center justify-between gap-3 py-2.5 sm:py-3">
        <div className="flex items-center gap-2.5 sm:gap-4 min-w-0">
          <Link to="/" aria-label="Home" className="shrink-0">
            <img src="/logo-light.png" alt="Pumpkin & Porch logo" data-testid="nav-logo" className="h-10 w-10 sm:h-12 sm:w-12 object-contain" />
          </Link>
          <Link to="/" data-testid="nav-brand-logo" className="leading-tight min-w-0">
            <div className="font-serif-display text-base sm:text-2xl tracking-wide whitespace-nowrap truncate" style={{ color: "var(--pp-parchment)" }}>
              Pumpkin <span className="italic font-light">&amp;</span> Porch
            </div>
            <div className="pp-caption hidden sm:block" style={{ color: muted }}>Seasonal Porch Styling</div>
          </Link>
          {!isHome && (
            <button onClick={goBack} data-testid="nav-back-button" className="pp-btn-ghost ml-1 sm:ml-2 shrink-0" style={{ color: muted }}>
              <ArrowLeft className="h-4 w-4" /> <span className="hidden sm:inline">Back</span>
            </button>
          )}
        </div>
        <nav className="flex items-center justify-end gap-3 sm:gap-6 text-sm whitespace-nowrap shrink-0">
          <Link to="/" data-testid="nav-home-link" aria-label="Home" title="Home" className={`pp-btn-ghost ${isHome ? "hidden sm:inline-flex" : ""}`} style={{ color: muted }}>
            <Home className="h-[18px] w-[18px]" strokeWidth={1.5} />
          </Link>
          <Link to="/care" data-testid="nav-care-link" className="hidden sm:inline pp-btn-ghost" style={{ color: muted }}>
            Care tips
          </Link>
          <Link to="/lookup" data-testid="nav-lookup-link" className={`pp-btn-ghost ${isHome ? "hidden sm:inline" : ""}`} style={{ color: muted }}>
            <span className="sm:hidden">Reservation</span><span className="hidden sm:inline">My reservation</span>
          </Link>
          {isHome && (
            <a href="#collections" data-testid="nav-book-now-button" className="pp-btn !rounded-full !py-2 !px-3.5 sm:!px-5 !text-[0.6rem] sm:!text-[0.7rem] !font-normal">
              <span className="sm:hidden">Availability</span><span className="hidden sm:inline">Check availability</span>
            </a>
          )}
        </nav>
      </div>
    </header>
  );
};
